export function extractBaseHrefFromCsr(): string {
  const url: URL = new URL(document.getElementsByTagName('base')[0].href);
  return url.pathname;
}
